import { type CSSProperties, type FunctionComponent, type PropsWithChildren, useState } from 'react';
import HelpCircleIcon from '../../svgs/help-circle.svg';
import { Popover } from '../popover/popover.component';
import { helpIconPopoverWidth } from './helpIcon.css';

export type HelpIconProps = {
	/**
	 * classes to apply for the popover container
	 */
	className?: string;

	/**
	 * classes to apply for the icon
	 */
	iconClassName?: string;

	/**
	 * classes to apply for the toggle element
	 */
	toggleElementClassName?: string;

	direction?: 'top' | 'bottom';
	customPopOverOffsetPixels?: Pick<CSSProperties, 'left' | 'top'>;
};

export const HelpIcon: FunctionComponent<PropsWithChildren<HelpIconProps>> = ({
	children,
	className = helpIconPopoverWidth,
	iconClassName,
	toggleElementClassName,
	direction = 'top',
	customPopOverOffsetPixels
}) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<Popover
			toggleElementClassName={toggleElementClassName}
			popOverClassName={className}
			isVisible={isOpen}
			setIsVisible={setIsOpen}
			direction={direction}
			customPopOverOffsetPixels={customPopOverOffsetPixels}
			toggleElement={<HelpCircleIcon className={`pointer ${iconClassName || ''}`} data-testid="HelpCircleIcon" />}>
			{children}
		</Popover>
	);
};
